export const dataText = {
    en: {
      title: 'Oops! site under maintenance',
      text: 'Sorry for the trouble, we are performing maintenance tasks to optimize your user experience.'
    },
    es: {
      title: '¡Ups! sitio en mantenimiento',
      text: 'Disculpe las molestias, estamos realizando tareas de mantenimiento para optimizar su experiencia de usuario.'
    },
    pt: {
      title: 'Ops! Site em manutenção',
      text: 'Desculpe pelo transtorno, estamos realizando tarefas de manutenção para otimizar a experiência do usuário.'
    }
  };
  